module.exports = __webpack_public_path__ + "static/media/silestone.4aa3b823.svg";